import { useQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import {
  StreamCardFragmentFragment,
  StreamCategory,
  StreamState,
} from '@/__generated__/graphql';
import { gql } from '@/__generated__/index.ts';

export const StreamsWeLoveQuery = gql(`
  query StreamsWeLoveQuery(
    $limit: Int!
    $nextToken: String
    $streamCategory: StreamCategory
    $streamState: StreamState
  ) {
    streamsAll(
      limit: $limit
      nextToken: $nextToken
      streamCategory: $streamCategory
      streamState: $streamState
      isFeatured: true
    ) {
      items {
        ...StreamCardFragment
      }
      nextToken
    }
  }
`);

export const useStreamsWeLove = ({
  limit = 6,
  nextToken,
  streamCategory,
  streamState = StreamState.Active,
}: {
  limit?: number;
  nextToken?: string;
  streamCategory?: StreamCategory;
  streamState?: StreamState;
} = {}) => {
  const toast = useToast();
  const { data, refetch, loading, error } = useQuery(StreamsWeLoveQuery, {
    variables: {
      limit,
      nextToken: nextToken || null,
      streamCategory: streamCategory || null,
      streamState,
    },
    onError: () => {
      toast.error({
        title: 'Failed to fetch streams',
      });
    },
  });

  return {
    streams: data?.streamsAll?.items as StreamCardFragmentFragment[] | null,
    areStreamsWeLoveEmpty: data?.streamsAll?.items?.length === 0,
    nextToken: data?.streamsAll?.nextToken,
    loading,
    refetch,
    error,
  };
};
